<template>
  <div class="point-rank-wrapper" >
    <Table v-if="showPagin" class="io-table" v-bind="table"  :height="height" :key="height"></Table>
    <Table v-else v-bind="table"></Table>
     <Pagination
          v-if="showPagin"
          v-bind="pagination"
          class="page-pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
        />
  </div>
</template>

<script>
import { getPointSumRank } from '@/api/workBench'
import Table from '@/components/page/Table.vue'
import Pagination from '@/components/page/Pagination.vue'
export default{
  components: {
    Table,
    Pagination
  },
  props: {
    showPagin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      table: {
        selection: false, // 是否开启选择框
        hiddenOperate: true,
        tableInfo: [{
          key: 'nickName',
          name: '姓名'
        }, {
          key: 'point',
          name: '积分'
        }],
        tableData: []
      },
      pagination: {
        total: 1,
        currentPage: 1,
        pageSize: 10
      },
      height: '300'
    }
  },
  computed: {
    params () {
      return {
        current: this.pagination.currentPage,
        size: this.pagination.pageSize
      }
    }
  },
  created () {
    this.getPointRank()
  },
  mounted () {
    if (this.showPagin) {
      const screenHeight = parseInt(window.innerHeight * 0.4)
      this.T = setTimeout(() => {
        const dom = document.querySelector('.io-table')
        const tableBody = dom.querySelector('.el-table__body')
        this.height = String(tableBody.clientHeight < screenHeight ? 300 : screenHeight)
        clearTimeout(this.T)
      }, 80)
    }
  },
  methods: {
    getPointRank () {
      getPointSumRank(this.params).then(({success, data}) => {
        if (success) {
          const {records, total} = data
          this.$set(this.table, 'tableData', records)
          this.$set(this.pagination, 'total', total)
        }
      })
    },
    currentChange (current) {
      this.$set(this.pagination, 'currentPage', current)
      this.getPointRank()
    },
    sizeChange (size) {
      this.$set(this.pagination, 'ccurrentPage', 1)
      this.$set(this.pagination, 'pageSize', size)
      this.getPointRank()
    }
  }
}
</script>

<style lang="scss" scoped>
.point-rank-wrapper{
  width: 100%;
  height: 100%;
  font-size: 14px;
}
.page-pagination{
  padding-top: 20px;
}
::v-deep .el-dialog .el-dialog__footer{
  border: none!important;
}

::v-deep .el-table__fixed-right {
  right: 0 !important;
  // bottom: 0 !important;
}
::v-deep .el-table__body-wrapper {
  &::-webkit-scrollbar {
    // 整个滚动条
    width: 0; // 纵向滚动条的宽度
    background: rgba(213, 215, 220, 0.3);
    border: none;
  }
  &::-webkit-scrollbar-track {
    // 滚动条轨道
    border: none;
  }
}

// --------------------隐藏table gutter列和内容区右侧的空白 start
::v-deep .el-table th.gutter {
  display: none;
  width: 0;
}
::v-deep .el-table colgroup col[name="gutter"] {
  display: none;
  width: 0;
}

::v-deep .el-table__body {
  width: 100% !important;
}


</style>